import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';
import { filter, switchMap, takeUntil } from 'rxjs';

import { IVideoSequencer, SdVideoSequencerComponent } from '@seb/web-design-system/video-sequencer';
import { SdSpyTargetDirective } from '@seb/web-design-system/core';

import { AbstractComponent } from '../abstract-component.component';
import { VideoSequencerComponentInterface } from '../../../models';
import { ComponentService, ImageService } from '../../../services';
import { WrapperComponent } from '../../../components/static/core';

@Component({
  selector: 'wc-video-sequencer',
  templateUrl: './video-sequencer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    WrapperComponent,
    SdVideoSequencerComponent,
    SdSpyTargetDirective
  ]
})
export class VideoSequencerComponent extends AbstractComponent<VideoSequencerComponentInterface> implements OnInit {
  @Input() class = '';

  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'wc-component is-cms'].filter(Boolean).join(' ');
  }

  videoSequencer: IVideoSequencer;

  constructor(
    private componentService: ComponentService,
    private imageService: ImageService,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  static areMandatoryFilled(cmp: VideoSequencerComponentInterface): boolean {
    return !!cmp.video && !!cmp.sequences;
  }

  ngOnInit(): void {
    this.component$
      .pipe(
        this.componentService.reloadComponentForArrayProperties(['video']),
        filter((cmp) => VideoSequencerComponent.areMandatoryFilled(cmp)),
        switchMap((cmp: VideoSequencerComponentInterface) =>
          this.componentService.getLazyComponentData(cmp, 'sequences')
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((cmp: VideoSequencerComponentInterface) => {
        this.videoSequencer = {
          medias: Object.values(cmp.video).map((video) => this.imageService.normalizeMedia(video)),
          cuePoints: cmp.sequencesObjects.map((sequence) => ({
            ...sequence,
            time: Number(sequence.time)
          }))
        };
        this.setLoaded();
        this.cdRef.markForCheck();
      });
  }
}
